module.exports = __webpack_public_path__ + "static/media/favicon.cff769f1.svg";